import { Box, Button, Card, CardActions, CardContent, CircularProgress, Container, Grid, Skeleton, Stack, Typography } from '@mui/material';
import logo from 'assets/images/staff.png';
import { ConfigurationContext } from 'components/provider/OrginazationContext';
import ModalForm from 'components/ui/Modal/UserModal';
import moment from 'moment';
import { useContext, useState } from 'react';
import { BiLoader, BiRefresh } from 'react-icons/bi';
import { useNavigate } from 'react-router-dom';
import { backendURL, nascsubdomain } from 'redux/reducers/settings';
import { useGetTrainingRoutineQuery } from 'redux/reducers/user/dashboard';
import { useCourseRosterQuery } from 'redux/reducers/user/dashboard/tms-dashboardTrainee';
import RoutineDetailSchedule from './CourseDetailAndSchedule';

const ModuleCard = () => {
  const navigate = useNavigate();
  const {
    data: trainingRoutine = [],
    isLoading,
    isFetching,
    isError,
    refetch
  } = useGetTrainingRoutineQuery(`active`);
  const [selectedModule, setSelectedModule] = useState({
    routineId: '',
    moduleId: ''

  });

  const { data: rosterDetail, isLoading: isLoadingRoster } = useCourseRosterQuery(
    selectedModule?.routineId ?? '',
    selectedModule?.moduleId
  );
  const { appConfig } = useContext(ConfigurationContext);


  return (
    <Container maxWidth="xl" sx={{ px: 0 }}>
      {isLoading ? (
        <Grid container spacing={3}>
          {[0, 1, 2].map((item) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={item}>
              <Skeleton variant="rectangular" height={330} sx={{ borderRadius: 4 }} />
            </Grid>
          ))}
        </Grid>
      ) : isError ? (
        <Box sx={{ textAlign: 'center', py: 8, bgcolor: 'action.hover', borderRadius: 4, border: '1px solid', borderColor: 'divider' }}>
          <Typography color="text.secondary" sx={{ mb: 2 }}>
            Unable to load your ongoing training.
          </Typography>
          <Button
            variant="outlined"
            size="small"
            onClick={() => refetch()}
            disabled={isFetching}
            startIcon={isFetching ? <CircularProgress size={14} /> : <BiRefresh size={18} />}>
            Reload
          </Button>
        </Box>
      ) : !trainingRoutine?.length ? (
        <Box sx={{ textAlign: 'center', py: 10, bgcolor: 'action.hover', borderRadius: 4, border: '1px solid', borderColor: 'divider' }}>
          <Typography color="text.secondary">You are not currently enrolled in any active training.</Typography>
        </Box>
      ) : (
        <Grid
          container
          spacing={3}
          sx={{ opacity: isFetching ? 0.6 : 1, transition: 'opacity 0.2s ease' }}>
          {trainingRoutine.map((item: any, index: number) => (
            <Grid item xs={12} sm={6} md={4} lg={4} key={index}>
              <Card
                elevation={0}
                sx={{
                  height: '100%', borderRadius: 4, cursor: 'pointer',
                  border: '1px solid', borderColor: 'divider',
                  transition: 'all 0.3s cubic-bezier(0.4, 0, 0.2, 1)',
                  '&:hover': { transform: 'translateY(-5px)', boxShadow: '0 8px 30px rgba(0,0,0,0.08)', borderColor: 'primary.main' }
                }}
              >
                <Box sx={{ bgcolor: '#f8f9fa', p: 4, display: 'flex', justifyContent: 'center' }}>
                  <img
                    src={appConfig?.domain_name==nascsubdomain?logo: item.training?.image ? backendURL + item.training?.image : logo}
                    alt={item?.training?.training_name}
                    style={{ height: '100px', objectFit: 'contain' }}
                  />
                </Box>

                <CardContent sx={{ p: 3 }}>
                  <Typography variant="subtitle1" sx={{ fontWeight: 800, height: 50, overflow: 'hidden', mb: 2, lineHeight: 1.3 }}>
                    {item?.training?.training_name}
                  </Typography>

                  <Stack direction="row" justifyContent="space-between" sx={{ mb: 2 }}>
                    <Box>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontWeight: 600 }}>START</Typography>
                      <Typography variant="body2" sx={{ fontWeight: 700 }}>{moment(item.start_date).format('MMM D, YYYY')}</Typography>
                    </Box>
                    <Box sx={{ textAlign: 'right' }}>
                      <Typography variant="caption" color="text.secondary" sx={{ display: 'block', fontWeight: 600 }}>END</Typography>
                      <Typography variant="body2" color="primary.main" sx={{ fontWeight: 700 }}>{moment(item?.end_date).format('MMM D, YYYY')}</Typography>
                    </Box>
                  </Stack>
                  <CardActions>
                    <Stack direction="column" gap={2} sx={{ width: '100%' }}>
                      <Button
                        size="small"
                        className='border'
                        onClick={() => navigate(`/training/${item.id}`)}>
                        View Details
                      </Button>
                      <Button
                        className='border'

                        size="small" onClick={() => {
                          setSelectedModule({
                          moduleId: item?.training?.course_details?.course_id,
                           routineId
                            : item?.id
                        })}}>
                        View Schedule
                      </Button>
                    </Stack>
                  </CardActions>


                  {/* <CardActions>
                    <Stack direction="row" justifyContent="space-between" sx={{ width: '100%' }}>
                      <Button
                        fullWidth
                        variant="outlined"
                        size="small"
                        sx={{ borderRadius: '50px', fontWeight: 700, textTransform: 'none' }}
                      >
                        View Details
                      </Button>
                      <Button size="small" onClick={() => setSelectedModule({
                        moduleId:item.id,
                        routineId:item.id
                      })}>
                        View Schedule
                      </Button>
                    </Stack>
                  </CardActions> */}


                </CardContent>
              </Card>
            </Grid>
          ))}
        </Grid>
      )}


      <ModalForm
        title="Schedule Details"
        open={!!selectedModule?.routineId}
        modalSize="xl"
        onClose={() => setSelectedModule({
          moduleId: '',
          routineId: ''
        })}>
        {isLoadingRoster ? (
          <BiLoader />
        ) : selectedModule?.routineId ? (
          <RoutineDetailSchedule
           routineId={selectedModule?.routineId} />
        ) : (
          <Typography textAlign="center">Failed to load schedule details</Typography>
        )}

        <Box sx={{ display: 'flex', justifyContent: 'end' }}>
          <Button title="close" variant="contained" onClick={() => setSelectedModule({
            moduleId: '',
            routineId: ''
          })}>
            Close
          </Button>
        </Box>
      </ModalForm>
    </Container>
  );
};

export default ModuleCard;